import * as React from "react";

const Workflow: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_20493_37418)">
      <path
        d="M3.75 12V9.75C3.75 9.55109 3.82902 9.36032 3.96967 9.21967C4.11032 9.07902 4.30109 9 4.5 9H13.5C13.6989 9 13.8897 9.07902 14.0303 9.21967C14.171 9.36032 14.25 9.55109 14.25 9.75V12M9 9V6M12.75 12H15.75C16.1642 12 16.5 12.3358 16.5 12.75V15.75C16.5 16.1642 16.1642 16.5 15.75 16.5H12.75C12.3358 16.5 12 16.1642 12 15.75V12.75C12 12.3358 12.3358 12 12.75 12ZM2.25 12H5.25C5.66421 12 6 12.3358 6 12.75V15.75C6 16.1642 5.66421 16.5 5.25 16.5H2.25C1.83579 16.5 1.5 16.1642 1.5 15.75V12.75C1.5 12.3358 1.83579 12 2.25 12ZM7.5 1.5H10.5C10.9142 1.5 11.25 1.83579 11.25 2.25V5.25C11.25 5.66421 10.9142 6 10.5 6H7.5C7.08579 6 6.75 5.66421 6.75 5.25V2.25C6.75 1.83579 7.08579 1.5 7.5 1.5Z"
        stroke="#8639ff"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_20493_37418">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default Workflow;
